import React from 'react'

import { FormattedCurrency, Loader, formatCurrency } from '@web/walter-ui-kit'
import { GetCard } from '@web/walter-lib/api'
import cn from 'classnames'
import { useIntl } from 'react-intl'
import s from './s.module.css'
import { useCardBalance } from '~api'
import CardImage from '~pages/CardsPage/components/CardImage'

interface Props {
    card?: GetCard
    isCurrent?: boolean
}

const getMantis = (balance?: string) => {
    const mantis = (balance || '0').split('.')[1]

    if (mantis && mantis.length === 1) {
        return mantis + '0'
    }

    return mantis ? mantis?.slice(0, 2) : '00'
}

const useShowCurrencyPostfix = (currency?: string) => {
    const intl = useIntl()

    const stringCurrency = formatCurrency(intl.locale, { value: 1, currency })
    if (/^1/?.test(stringCurrency.trim())) {
        return true
    }

    return false
}

// eslint-disable-next-line complexity
function Balance({ card, isCurrent = true }: Props) {
    const showBalance =
        isCurrent && (card?.status === 'ACTIVE' || card?.status === 'SUSPENDED' || card?.status === 'BLOCKED')

    const { data, isLoading } = useCardBalance({ id: card?.id || '' }, { shouldRequest: showBalance })
    const showNumbers = card?.status !== 'FAILED'

    const showBlocked = card?.status === 'BLOCKED' || card?.status === 'SUSPENDED'
    const showCurrencyPostfix = useShowCurrencyPostfix(data?.currency)

    return (
        <div className={s.wrap}>
            <div className={s.img}>
                <CardImage designId={card?.card_design?.id} status={card?.status} cardType={card?.card_type} />
            </div>
            <div className={cn(s.amountWrap, showBlocked && s.amountWrapSusp)}>
                {showBalance &&
                    (isLoading ? (
                        <Loader width={30} height={20} className={s.loader} />
                    ) : (
                        <span>
                            <FormattedCurrency
                                maxPrecision={0}
                                value={data?.available_balance}
                                dataPointer="balance"
                                className={showBlocked ? s.mantis : s.titleBalance}
                                currency={!showCurrencyPostfix ? data?.currency : undefined}
                            />
                            {data?.available_balance ? (
                                <span className={s.mantis}>.{getMantis(data?.available_balance)}</span>
                            ) : null}
                            {showCurrencyPostfix && (
                                <span className={showBlocked ? s.mantis : s.currency}> {data?.currency}</span>
                            )}
                        </span>
                    ))}
                {showNumbers && (
                    <span className={showBlocked ? s.mantis : undefined}>·· {card?.masked_number || '****'}</span>
                )}
            </div>
        </div>
    )
}

export default Balance
